import React from "react";
import { Box, Grid, Typography, Container, styled } from "@mui/material";
import YouTube from "react-youtube";
import "animate.css";

// Styled section container
const VideoSection = styled(Box)(({ theme }) => ({
  textAlign: "center",
  padding: theme.spacing(8, 0),
  backgroundColor: "#121212",
  color: "#fff",
}));

// Wrapper for spacing
const VideoBox = styled(Box)(({ theme }) => ({
  margin: "0 auto",
  maxWidth: "100%",
  borderRadius: theme.shape.borderRadius,
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
  overflow: "hidden",
}));

const SalonVideos = () => {
  const videoIds = [
    "uM9IUhaQL54", // Replace with your actual salon video IDs
    "4dcgm58J1uk",
    "CV8J8i6bDWI",
  ];

  const opts = {
    height: "315",
    width: "100%",
    playerVars: {
      autoplay: 0, // set to 1 to autoplay
      modestbranding: 1,
      rel: 0,
      showinfo: 0,
    },
  };

  return (
    <VideoSection id="salon-videos">
      <Container maxWidth="lg">
        <Typography variant="h4" gutterBottom>
          Watch Our Salon in Action
        </Typography>
        <Typography variant="subtitle1" color="textSecondary" paragraph>
          See our threading, facials, and hair transformations in motion.
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          {videoIds.map((id) => (
            <Grid item xs={12} sm={6} md={4} key={id}>
              <VideoBox>
                <YouTube videoId={id} opts={opts}></YouTube>
              </VideoBox>
            </Grid>
          ))}
        </Grid>
      </Container>
    </VideoSection>
  );
};

export default SalonVideos;
